export default __webpack_public_path__ + "static/media/whyVisit4.1e89c6d3.svg";